import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SignUpInviteCode from "./components/SignUpInviteCode";
import SignUpEmail from "./components/SignUpEmail";
import CreatePassword from "./components/CreatePassword";
import CreateUsername from "./components/CreateUsername";
import MoreInformation from "./components/MoreInformation";
import JoinWaitlist from "./components/JoinWaitlist";
import WaitlistSuccess from "./components/WaitlistSuccess";
import { useLocation } from "react-router-dom";
import { RootState } from "@/store/store";
import { setSignUpData } from "@/store/slice/signUpSlice";
import { RegisterUserRequest } from "@/store/api/authApiData";

const SignUp = () => {
  const [signUpStep, setSignUpStep] = useState(0);
  const [waitlistEmail, setWaitlistEmail] = useState("");
  const dispatch = useDispatch();
  const signUpData = useSelector((state: RootState) => state.signUp);
  const location = useLocation();

  useEffect(() => {
    const step = location.state?.step;
    const email = location.state?.email;
    if (step !== undefined && email !== undefined) {
      setSignUpStep(step);
      dispatch(setSignUpData({ email }));
    }
  }, [location.state, dispatch]);

  return (
    <>
      {signUpStep === 0 && (
        <SignUpInviteCode
          setSignUpStep={setSignUpStep}
          signUpData={signUpData}
          setSignUpData={(data: Partial<RegisterUserRequest>) => dispatch(setSignUpData(data))}
        />
      )}
      {signUpStep === 1 && (
        <SignUpEmail
          setSignUpStep={setSignUpStep}
          signUpData={signUpData}
          setSignUpData={(data: Partial<RegisterUserRequest>) => dispatch(setSignUpData(data))}
        />
      )}
      {signUpStep === 2 && (
        <CreatePassword
          setSignUpStep={setSignUpStep}
          signUpData={signUpData}
          setSignUpData={(data: Partial<RegisterUserRequest>) => dispatch(setSignUpData(data))}
        />
      )}
      {signUpStep === 3 && (
        <CreateUsername
          setSignUpStep={setSignUpStep}
          signUpData={signUpData}
          setSignUpData={(data: Partial<RegisterUserRequest>) => dispatch(setSignUpData(data))}
        />
      )}
      {signUpStep === 4 && (
        <MoreInformation
          setSignUpStep={setSignUpStep}
          signUpData={signUpData}
          setSignUpData={(data: Partial<RegisterUserRequest>) => dispatch(setSignUpData(data))}
        />
      )}
      {signUpStep === 5 && (
        <JoinWaitlist setSignUpStep={setSignUpStep} setWaitlistEmail={setWaitlistEmail} />
      )}
      {signUpStep === 6 && (
        <WaitlistSuccess setSignUpStep={setSignUpStep} email={waitlistEmail} />
      )}
    </>
  );
};

export default SignUp;
